module.exports = __webpack_public_path__ + "img/erweima.e4a1c123.png";